module.exports = __webpack_public_path__ + "img/grey-help-circle.23fd784e.svg";